import React, { useState } from 'react';
import { Skeleton } from '@mui/material';
import { StyledImg } from '@/components/EntityLogo/EntityLogo.styled';

interface IEntityLogoProps {
  companyName: string;
  height?: string;
}

export const EntityLogo = ({ companyName, height = '40px' }: IEntityLogoProps) => {
  // 65px is set up for logo render in SummeryMetrics component needs
  const skeletonSize = height.endsWith('%') ? '65px' : height;

  return (
    <EntityLogoImage
      key={companyName}
      companyName={companyName}
      height={height}
      skeletonSize={skeletonSize}
    />
  );
};

interface IEntityLogoImageProps {
  companyName: string;
  height: string;
  skeletonSize: string;
}

const EntityLogoImage = ({ companyName, height, skeletonSize }: IEntityLogoImageProps) => {
  const imagePath = `https://cdn.agioratings.io/icons/${companyName.replace('.', '_').replace('-', '_')}.png`;
  const placeholderPath = 'https://cdn.agioratings.io/icons/logo.png';

  const [isPrimaryImage, setIsPrimaryImage] = useState(true);
  const [isUploading, setIsUploading] = useState(true);

  const handleLoad = () => {
    setIsUploading(false);
  };

  const handleError = () => {
    if (isPrimaryImage) {
      console.warn(`Missing logo: ${companyName}`);
      setIsPrimaryImage(false);
      return;
    }

    setIsUploading(false);
  };

  return (
    <>
      {isUploading && (
        <Skeleton
          variant="circular"
          animation="wave"
          width={skeletonSize}
          height={skeletonSize}
          sx={{
            bgcolor: 'customSecondary.neutral.400',
            '&::after': {
              background: `linear-gradient(
                90deg,
                transparent,
                rgba(255, 255, 255, 0.25),
                transparent
              )`,
            },
          }}
        />
      )}
      <StyledImg
        src={isPrimaryImage ? imagePath : placeholderPath}
        alt={companyName}
        onLoad={handleLoad}
        onError={handleError}
        height={height}
        style={{ objectFit: 'cover', display: isUploading ? 'none' : 'block' }}
      />
    </>
  );
};
